<router-outlet></router-outlet>

<notifier-container></notifier-container>
<!-- <app-pill-loader *ngIf="loadingLibertyRxInventory$ | async" #pillLoader></app-pill-loader> -->
<ng-template #customNotification let-notificationData="notification">
  <app-alert
    [global]="true"
    [hasCustomCloseButton]="notificationData.hasCloseButton"
    (closeAlert)="closeAlert(notificationData.id)"
    [message]="notificationData.message"
    [type]="notificationData.type"
  ></app-alert>
</ng-template>

<app-alert *ngIf="(alertService?.alertMessage$) | async; let message"
    [show]="true"
    [message]="message.content"
    [type]="message.type"
    class="alert"
    maxWidth="1000px"
    [autohide]="message.autoHide || 4"
    [style.width]="message.width"
    [closeButtonName]="message.closeButtonName || 'close-steel-gray'"
    (closeAlert)="alertService.alertMessage$.next(null)"
    [global]="true"
></app-alert>

<app-enter-pin-dialog *ngIf="(pinService.showPinDialog$ | async)"
    [show]="true"
    [focusPin]="pinService.focusPin"
    (cancel)="pinService.closeDialog()"
    (setPinHandler)="pinService.validatePin($event)"
    (handleResetPin)="pinService.openResetPinDialog()"
></app-enter-pin-dialog>

<app-enter-pin-dialog *ngIf="(pinService.showWitnessPinDialog$ | async); let witness"
    [show]="true"
    [focusPin]="pinService.focusPin"
    (cancel)="pinService.closeDialog()"
    [isWitness]="witness"
    (setPinHandler)="pinService.validatePin($event)"
    (handleResetPin)="pinService.openResetPinDialog()"
></app-enter-pin-dialog>

<app-reset-pin-dialog *ngIf="pinService.showResetPinDialog$ | async"
                      [show]="true"
                      (cancel)="pinService.closeResetPinDialog()"
                      (afterUpdate)="pinService.afterPinUpdated($event)"
></app-reset-pin-dialog>

<app-user-message-dialog></app-user-message-dialog>